import { useState } from "react";
import { UpOutlined, DownOutlined, EditOutlined } from "@ant-design/icons";
import { Button, List } from "antd";
import dayjs from "dayjs";

import useDelete from "hooks/useDelete";
import useCreate from "hooks/useCreate";

import ModalDelete from "components/ModalDelete";
import EditIssueKindProblemModal from "../EditIssueKindProblemModal";

const Item = ({ id, name, created_at, refetch, is_first, is_last }) => {
  const [is_open_edit_comment_modal, setIsOpenEditIssueKindProblemModal] =
    useState(false);

  const { is_deleting, _delete } = useDelete({
    path: `/issue_kind_problems/${id}`,
    onSuccess: refetch,
  });

  const { is_saving: is_saving_move_up, create: moveUp } = useCreate({
    path: `/issue_kind_problems/${id}/move_up`,
    onSuccess: refetch,
    success_message: "Przeniesiono w górę",
  });

  const { is_saving: is_saving_move_down, create: moveDown } = useCreate({
    path: `/issue_kind_problems/${id}/move_down`,
    onSuccess: refetch,
    success_message: "Przeniesiono w dół",
  });

  return (
    <List.Item
      actions={[
        <Button
          loading={is_saving_move_up}
          disabled={is_first}
          onClick={() => moveUp()}
          type="primary"
          ghost
          icon={<UpOutlined />}
        />,
        <Button
          disabled={is_last}
          onClick={() => moveDown()}
          type="primary"
          ghost
          loading={is_saving_move_down}
          icon={<DownOutlined />}
        />,
        <Button
          onClick={() => setIsOpenEditIssueKindProblemModal(true)}
          type="primary"
          ghost
          icon={<EditOutlined />}
        />,
        <ModalDelete
          loading={is_deleting}
          only_icon={true}
          text={`najczęsciej zgłaszany problem "${name}"`}
          handleDelete={_delete}
        />,
      ]}
    >
      <List.Item.Meta
        title={name}
        description={dayjs(created_at).format("DD-MM-YYYY HH:mm")}
      />
      {is_open_edit_comment_modal && (
        <EditIssueKindProblemModal
          refetch={refetch}
          issue_kind_problem_id={id}
          default_name={name}
          handleClose={() => setIsOpenEditIssueKindProblemModal(false)}
        />
      )}
    </List.Item>
  );
};

export default Item;
